import { gql } from "@apollo/client";

export default gql`
  query getComplianceProgramAssessments(
    $complianceProgramId: Int!
    $targetId: Int!
  ) {
    complianceProgram(pk: $complianceProgramId) {
      id
      assessments(targetId: $targetId, state: submitted) {
        edges {
          node {
            id
            state
            submittedDatetime
            template {
              id
              assessmentType
            }
            canUpdate {
              permission
              reason
            }
            responder {
              id
              name
              avatar
            }
            responderName
            responderDeactivated
            target {
              id
              name
              avatar
            }
          }
        }
      }
    }
  }
`;
